import * as actionTypes from "../constants";
import { axiosApiInstance } from "../../utils";
import { setLoading } from "./user_action";

// const BACKEND_API = process.env.REACT_APP_BACKEND_API_URL;
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

const setRestoreResponse = (response, pin) => {
  return {
    type: actionTypes.RESTORE_SET_RESPONSE,
    response,
    pin,
  };
};

export const setRestoreError = (error) => {
  return {
    type: actionTypes.CREATE_ERROR,
    error,
  };
};

const setUserVerified = (userVerified) => {
  return {
    type: actionTypes.SET_USER_VERIFIED,
    user_verified: userVerified,
  };
};

export const reset = () => {
  return {
    type: actionTypes.RESET,
  };
};

export const setUserDoesNotExist = (
  userDoesnotExist,
  userIdType,
  userIdNumber
) => {
  return {
    type: actionTypes.SET_USER_DOES_NOT_EXIST,
    user_does_not_exist: userDoesnotExist,
    user_id_type: userIdType,
    user_id_number: userIdNumber,
  };
};

export const editPin = (idType, idNumber, pin, email) => {
  return (dispatch) => {
    const requestConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };
    console.log(idNumber);

    const requestBody = {
      data: {
        document_type: idType,
        document_number: idNumber.toString().trim(),
        pin: pin,
        email: email,
      },
    };

    const editPinUrl = `/api/${ENVIRONMENT}/edit`;
    dispatch(setLoading(true));
    console.log(editPinUrl);
    console.log(requestBody);
    axiosApiInstance
      .post(editPinUrl, requestBody, requestConfig)
      .then(async (response) => {
        const restoreResponse = response.data.data;
        console.log("edit pin response: ", restoreResponse);
        dispatch(setRestoreResponse(restoreResponse, pin));
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.status &&
          error.response.status == 404
        ) {
          dispatch(setRestoreResponse(null, ""));
          console.error("user does not exist response");
          dispatch(setUserDoesNotExist(true, idType, idNumber));
        } else {
          dispatch(setRestoreError(true));
          dispatch(reset());
        }
      })
      .finally(() => {
        dispatch(setLoading(false));
        dispatch(setUserVerified(true));
      });
  };
};
